module.exports = __webpack_public_path__ + "static/media/car.117ee016.jpg";